export const MENU_PERMISSION_KEYS = [
  'DASHBOARD', 'PERFORMANCE', 'AGENDA', 'ALERTS',
  'OPPORTUNITIES', 'TENDER_CALENDAR', 'INTEGRATION_HEALTH', 'COMMERCIAL_DECISIONS', 'ANALYST', 'FAVORITES', 'FAVORITES_ARCHIVED', 'ONGOING', 'DOSSIERS', 'PARTICIPATION',
  'HOMOLOGATED', 'RESULTS',
  'ORDERS', 'CONTRACTS', 'PRODUCTS', 'COMMUNICATIONS', 'CHAT_MONITORING',
  'CERTIFICATES', 'DOCUMENTS', 'PORTALS', 'LEGAL', 'SETTINGS',
] as const;

export type MenuPermissionKey = (typeof MENU_PERMISSION_KEYS)[number];

export type MenuPermissionGroup = {
  label: string;
  items: Array<{ key: MenuPermissionKey; label: string }>;
};

export const MENU_PERMISSION_GROUPS: MenuPermissionGroup[] = [
  {
    label: 'Principal',
    items: [
      { key: 'DASHBOARD', label: 'Visão geral' },
      { key: 'PERFORMANCE', label: 'Indicadores' },
      { key: 'AGENDA', label: 'Agenda' },
      { key: 'ALERTS', label: 'Central de alertas' },
    ],
  },
  {
    label: 'Licitações',
    items: [
      { key: 'OPPORTUNITIES', label: 'Busca de oportunidade' },
      { key: 'TENDER_CALENDAR', label: 'Calendário de oportunidades' },
      { key: 'INTEGRATION_HEALTH', label: 'Saúde das integrações' },
      { key: 'COMMERCIAL_DECISIONS', label: 'Decisão comercial' },
      { key: 'ANALYST', label: 'Analista IA' },
      { key: 'FAVORITES', label: 'Licitações em Participação' },
      { key: 'FAVORITES_ARCHIVED', label: 'Participações arquivadas' },
      { key: 'ONGOING', label: 'Em andamento > Processos' },
      { key: 'DOSSIERS', label: 'Em andamento > Dossiês operacionais' },
      { key: 'PARTICIPATION', label: 'Em andamento > Participação' },
      { key: 'CHAT_MONITORING', label: 'Em andamento > Monitor de licitação' },
      { key: 'HOMOLOGATED', label: 'Homologadas' },
      { key: 'RESULTS', label: 'Resultados' },
    ],
  },
  {
    label: 'Operação',
    items: [
      { key: 'ORDERS', label: 'Empenhos & O.S.' },
      { key: 'CONTRACTS', label: 'Contratos' },
      { key: 'PRODUCTS', label: 'Produtos & serviços' },
      { key: 'COMMUNICATIONS', label: 'Ofícios & prazos' },
    ],
  },
  {
    label: 'Documentação',
    items: [
      { key: 'CERTIFICATES', label: 'Atestados técnicos' },
      { key: 'DOCUMENTS', label: 'Documentos e certidões' },
      { key: 'PORTALS', label: 'Portais' },
    ],
  },
  { label: 'Jurídico', items: [{ key: 'LEGAL', label: 'Gestão jurídica' }] },
  { label: 'Gestão', items: [{ key: 'SETTINGS', label: 'Configurações' }] },
];

export const ALL_MENU_PERMISSION_KEYS = [...MENU_PERMISSION_KEYS];

export function hasMenuPermission(
  user: { role?: string; menuKeys?: string[] } | null | undefined,
  key: MenuPermissionKey,
): boolean {
  if (user?.role === 'ADMIN') return true;
  // Sem matriz salva, mantemos a compatibilidade dos usuários atuais.
  if (!Array.isArray(user?.menuKeys)) return true;
  return user.menuKeys.includes(key);
}
